import React from 'react';
import BlockContent from '@sanity/block-content-to-react';

import { Text, Link } from '@chakra-ui/react';

const serializers = {
  types: {
    block: (props) => <Text textStyle="body">{props.children}</Text>,
  },
  marks: {
    link: ({ mark, children }) => {
      const { blank, href } = mark;
      return <Link href={href}>{children}</Link>;
    },
  },
};

const RichText = ({ data }) => (
  <BlockContent blocks={data.rte} serializers={serializers} />
);

export default RichText;
